import { render, staticRenderFns } from "./mentionsLegales.vue?vue&type=template&id=45544403"
import script from "./mentionsLegales.vue?vue&type=script&lang=js"
export * from "./mentionsLegales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderMentionsLegales: require('/home/etienne/AM-frontend/components/HeaderMentionsLegales.vue').default})
